import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import { PrismicRichText } from '@prismicio/react';
import { PrismicNextImage } from '@prismicio/next';
import '@/styles/ModernScrollbar.css';

/**
 * Props for `Timeline2`.
 */
export type Timeline2Props = SliceComponentProps<Content.Timeline2Slice>;

/**
 * Component for "Timeline2" Slices.
 */
const Timeline2 = ({ slice }: Timeline2Props): JSX.Element => {
  const {
    primary: { heading, events },
  } = slice;
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      style={{
        backgroundColor:
          slice.variation === 'modernTimeline' ? '#0F423A' : '#B6F6EA',
      }}
    >
      <div
        className={`container mx-auto px-5 md:px-0 h-full flex text-left justify-start items-start py-4 md:py-16 ${
          slice.variation === 'modernTimeline' ? 'text-white' : 'text-black'
        }`}
      >
        <div className="flex flex-col gap-y-7 w-full px-8">
          <div
            className="text-left pb-6"
            style={{
              fontWeight: '700',
              fontSize: '40px',
              lineHeight: '120%',
            }}
          >
            <PrismicRichText field={heading} />
          </div>
          <div
            className={`flex flex-row flex-nowrap overflow-x-auto w-full items-start gap-x-16 pb-8 ${
              slice.variation === 'modernTimeline'
                ? 'modern-scrollbar'
                : 'custom-scrollbar'
            }`}
          >
            {events.map((item, index) => (
              <div
                className="flex flex-col items-start gap-y-7 max-w-[20rem] min-w-[17rem] mx-auto"
                key={`timeline-event-${index}`}
              >
                <div
                  className={`relative ${
                    slice.variation === 'modernTimeline' ? 'mt-2' : ''
                  }`}
                >
                  {slice.variation === 'modernTimeline' && (
                    <div className="absolute left-0 top-1/2 transform -translate-y-1/2 w-4 h-4 bg-[#05F36C] rounded-full z-10"></div>
                  )}
                  <PrismicNextImage field={item.year_separator} />
                </div>
                <div
                  style={{
                    fontWeight: '700',
                    fontSize: '24px',
                    lineHeight: '140%',
                  }}
                >
                  <PrismicRichText field={item.event_year} />
                </div>
                <div
                  style={{
                    fontWeight: '700',
                    fontSize: '20px',
                    lineHeight: '150%',
                  }}
                >
                  <PrismicRichText field={item.event_title} />
                </div>
                <div
                  style={{
                    fontWeight: '500',
                    fontSize: '14px',
                    lineHeight: '150%',
                  }}
                >
                  <PrismicRichText field={item.event_description} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Timeline2;
